import { LocalBundleEnvelope } from '@cdaas/api-clients/dist/product-service-openapi';

export const isSelectedBundleAvailable = (bundle: LocalBundleEnvelope | null, chosenMainItemVariantId?: number): boolean => {
  if (!bundle || !chosenMainItemVariantId) {
    return false;
  }
  const bundleToCheck = bundle.bundle;
  const chosenVariant = (bundle.bundle.main_item.variants || []).find(variant => variant.id === chosenMainItemVariantId);
  if (!bundleToCheck || !chosenVariant?.available_amount || chosenVariant.available_amount < 1) {
    return false;
  }
  for (const addonItem of bundleToCheck.items) {
    if (!addonItem.options[0]?.available_amount || addonItem.options[0]?.available_amount < 1) {
      return false;
    }
  }
  return true;
};
